module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYAQMAAADaua+7AAAABlBMVEUAAAAAd9qjH200AAAAAXRSTlMAQObYZgAAADBJREFUCNdj+P/8PwMIH0hjBuNzacVwDBODqYGB/8/qwfhAWjIYnwPjejCG64GoAQDm0ykfJgXEQAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/icon_QR_code@2x.png
// module id = 9MYk
// module chunks = 69